import { Button } from 'antd'
import { useState, VFC } from 'react'
import { useTranslation } from 'react-i18next'

import { ImportEmployeesUploadCvs } from '@/components/pages/Employees/Import'
import ImportPageHeader from '@/components/pages/ImportPageHeader'

import { useImportDetergent } from './Import.hooks'

const ImportDetergent: VFC = () => {
  const [fileName, setFileName] = useState('')
  const [t] = useTranslation()
  const { loading, importCsvDetergent } = useImportDetergent()
  const [file, setFile] = useState<File | null>(null)

  const handleFileSelected = (data: FormData) => {
    const file = data.get('file') as File
    setFileName(file.name)
    setFile(file)
  }

  const handleSubmit = () => {
    if (file) {
      const payload = {
        nameIdx: 0,
        priceIdx: 1,
        netWeightGIdx: 2,
        netWeightMlIdx: 3,
        specificGravityIdx: 4,
        costPerMlIdx: 5,
        quantityIdx: 6,
        thresholdQuantityIdx: 7,
      }

      const formData = new FormData()
      formData.append('file', file)
      formData.append('payload', JSON.stringify(payload))

      importCsvDetergent(formData)
    }
  }

  return (
    <>
      <ImportPageHeader title={t('pages.detergents.importFromCsv.title')} />
      <ImportEmployeesUploadCvs loading={loading} onUpload={handleFileSelected} fileName={fileName} />
      <Button disabled={!fileName} type="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
        {t('pages.employees.importFromCsv.submit')}
      </Button>
    </>
  )
}

ImportDetergent.displayName = 'ImportDetergent'
export default ImportDetergent
